module.exports = __webpack_public_path__ + "static/level-10-card.18ba4ecf.png";